import { Icon } from '@eventbrite/eds-icon';
import { ChevronDownChunky } from '@eventbrite/eds-iconography';
import { Tag } from '@eventbrite/eds-tag';
import { gettext } from '@eventbrite/i18n';
import React from 'react';

interface DateFilterButtonProps {
    onClick: (render: boolean) => void;
    onClose: () => void;
    hasActiveDate: boolean;
}

export const DateFilterButton: React.FunctionComponent<
    DateFilterButtonProps
> = (props) => {
    const { onClick, onClose, hasActiveDate } = props;

    return (
        <Tag
            style="outlined"
            onActiveToggle={onClick}
            onClose={onClose}
            initialIsActive={false}
            isClosable={hasActiveDate}
        >
            {hasActiveDate ? props.children : <>{gettext('Date')}</>}
            {!hasActiveDate && (
                <>
                    <span style={{ paddingLeft: '4px' }} />
                    <Icon type={<ChevronDownChunky />} size="small" />
                </>
            )}
        </Tag>
    );
};
